import { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useTheme } from '@material-ui/core'
import * as Constants from '../services/Constants'
import { CommunityPageTabTypes, UserContext, UserContextType } from '../UserContext'
import { parseJoinRoomLink } from '../services/JoinRoomLink'
import ElectronIPC from '../services/ElectronIPC'
import useRootSnackbar from '../services/useRootSnackbar'
import CommunityContainer from './Community/CommunityContainer'
import Header from '@/components/LegacyHeader'
import useStyles from '@/components/LegacyStyles'
import Logout from './Logout'
import { ExternalEventEmitter } from '../ExternalEventEmitter'
import { ExternalEvent } from '../AppContext'
import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline } from '@material-ui/core'
import { dark as museDarkTheme } from '@/themes/museDarkTheme'

function MainCommunityPage({}: {}) {
    const classes = useStyles(useTheme())
    const history = useHistory()

    const { state, dispatch } = useContext(UserContext) as UserContextType

    const RootSnackbar = useRootSnackbar()

    const [showLogout, set_showLogout] = useState(false)

    const q = new URLSearchParams(history.location.search)

    useEffect(() => {
        ElectronIPC.setWindowBounds({
            width: Constants.session_settings_page_window_dim.width,
            height: Constants.session_settings_page_window_dim.height,
            isMaximized: false,
            constraintX: 'center',
            constraintY: 'center',
        })

        let tab = q.get('tab') as CommunityPageTabTypes
        if (tab) {
            dispatch({
                type: 'update_community_state',
                value: { communityPageCurrentTab: tab },
            })
        }

        ElectronIPC.setMenu({ menuName: 'startpage' })
    }, [])

    useEffect(() => {
        const handler = (externalEvent: ExternalEvent) => {
            if (externalEvent.eventName === 'join-room-link') {
                const { error, code } = parseJoinRoomLink(externalEvent.value)
                if (code) {
                    history.push(`/join/${code}`)
                }
                if (error) {
                    RootSnackbar.show({
                        severity: 'error',
                        message: 'Failed to parse join room link. ' + error.message,
                    })
                }
            } else if (externalEvent.eventName === 'menu-click') {
                const opcode = externalEvent.value?.opcode
                if (opcode === 'muse_about') {
                } else if (opcode === 'muse_accountinfo') {
                } else if (opcode === 'muse_signout') {
                    set_showLogout(true)
                }
            }
        }

        ExternalEventEmitter.on('event', handler)

        return () => {
            ExternalEventEmitter.removeListener('event', handler)
        }
    }, [])

    return (
        <ThemeProvider theme={museDarkTheme}>
            <CssBaseline />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingBottom: 24,
                    height: `calc(100% - ${Constants.title_bar_height})`,
                }}
                className="bg-[rgb(32,33,34)]"
            >
                <Header
                    isIndependentModal={false}
                    currMenuSelection={'community'}
                    title="Muse Community"
                    onGoBack={() => {
                        history.push('/')
                    }}
                />
                <CommunityContainer />
                {showLogout && <Logout />}
            </div>
        </ThemeProvider>
    )
}

export default MainCommunityPage
